/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ScheduleSiteChangeRequestDto } from '../scheduleSiteChangeRequestDto.schema';

export const SaveScheduleSiteChangeRequest = zod.object({
  "id": zod.string().uuid().optional(),
  "monthlyCoveragePlanId": zod.string().uuid().optional(),
  "payload": zod.lazy(() => ScheduleSiteChangeRequestDto).optional()
});

export type SaveScheduleSiteChangeRequest = zod.input<typeof SaveScheduleSiteChangeRequest>;
export type SaveScheduleSiteChangeRequestOutput = zod.output<typeof SaveScheduleSiteChangeRequest>;
